import React, { useState } from 'react';
import FilterPanel from '../components/mainAdvancedSearch/filterPanel';
import SearchListResult from '../components/mainAdvancedSearch/advancedSearch';
import { useSelector } from 'react-redux';
import { Card, EmptyState, PageHead } from '../components/ui';

const EMPTY_FILTER_ROW = [
    {
        id: 1,
        operator: 'AND',
        comparator: 'contains',
        information: 'Users',
        propertie: null,
        input: null,
        action: 'remove'
    }
];

export default function AdvancedSearch() {
    const { isAdvancedSearchActive } = useSelector((state) => state.advancedSearch);

    // Ne PAS réhydrater activeFilters depuis savedFilters : SearchListResult doit se
    // monter à chaque application de filtres, sinon son garde de cache interne
    // (savedFilters === filtersToUse) bloque le rafraîchissement des résultats.
    const [activeFilters, setActiveFilters] = useState(null);
    const [filterRow, setFilterRow] = useState(EMPTY_FILTER_ROW);

    return (
        <>
            <PageHead>
                <div>
                    <h2>Recherche avancée</h2>
                    <p>Filtres combinés sur les utilisateurs, appareils, groupes et applications d'entreprise Entra ID.</p>
                </div>
            </PageHead>

            <FilterPanel
                filterRow={filterRow}
                setFilterRow={setFilterRow}
                setActiveFilters={setActiveFilters}
            />

            {isAdvancedSearchActive && activeFilters ? (
                <SearchListResult
                    filters={activeFilters}
                    information={filterRow[0]?.information || 'Users'}
                />
            ) : (
                <Card>
                    <EmptyState>
                        <i className="bx bx-filter-alt" />
                        <h3>Aucun filtre actif</h3>
                        <p>Sélectionnez au moins un filtre, puis lancez la recherche.</p>
                    </EmptyState>
                </Card>
            )}
        </>
    )
}
